import { UserNotification } from './user-notification';

export class UserNotifications {

  constructor(
    public userNotifications?: UserNotification[],
    public totalPage?: number,
    public total?: number
  ) { }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/user-notifications.ts